module.exports = __webpack_public_path__ + "img/momo.874fe9e3.png";